export var commandSaferGamblingModalsStart = {
  topic: 'wh.common.command.account.action.execute',
  data: {
    eventId: 'event.account.safer.gambling.modals.start.requested'
  }
};